module.exports = __webpack_public_path__ + "static/media/image_79.2e700349.png";